/**
 * Reset Password
 */
import React from 'react';
import { Helmet } from 'react-helmet';
import { Grid, Segment } from 'semantic-ui-react';

// @ts-ignore
import { ErrorBoundary } from '../../workspaces/redux-error-boundary';

// Components
// @ts-ignore
import ErrorBoundaryAlert from '../../components/ErrorBoundaryAlert';
import ResetPasswordForm from './components/ResetPasswordForm';

// Environment
const { REACT_APP_PROJECT_NAME, REACT_APP_VERSION } = process.env;

export function ResetPassword(): React.ReactElement {
    return (
        <ErrorBoundary
            namespace="ResetPassword"
            FallbackComponent={<ErrorBoundaryAlert />}
        >
            <Helmet>
                <title>{`Organization - ${REACT_APP_PROJECT_NAME}`}</title>
            </Helmet>
            <Grid textAlign="center" padded style={{ height: '100%' }}>
                <Grid.Column style={{ maxWidth: 450 }} verticalAlign="middle">
                    <Segment textAlign="left">
                        {/* @ts-ignore */}
                        <ResetPasswordForm />
                    </Segment>
                    <p style={{ textAlign: 'center' }}>v{REACT_APP_VERSION}</p>
                </Grid.Column>
            </Grid>
        </ErrorBoundary>
    );
}

export default ResetPassword;
